import { useState } from "react";
import { Printer, FileDown, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { errMsg } from "@/lib/api";
import { printSlips, downloadSlips } from "@/lib/slips";
import { toast } from "sonner";

export function SlipButton({ ids, mode = "print", label, testid, size = "sm", variant = "outline", className = "" }) {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { await (mode === "print" ? printSlips(ids) : downloadSlips(ids)); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const Icon = mode === "print" ? Printer : FileDown;
  return (
    <Button size={size} variant={variant} className={className} onClick={go} disabled={busy || !ids.length} data-testid={testid}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Icon className="h-4 w-4" />} {label}
    </Button>
  );
}

export function SlipActions({ ids, prefix, printLabel = "Print Advance Slip", downloadLabel = "Download PDF" }) {
  return (
    <div className="flex flex-wrap gap-2">
      <SlipButton ids={ids} mode="print" label={printLabel} testid={`${prefix}-print`} size="default" variant="default" className="bg-blue-800 hover:bg-blue-900" />
      <SlipButton ids={ids} mode="download" label={downloadLabel} testid={`${prefix}-download`} size="default" />
    </div>
  );
}
